import { API_ROOT } from 'environment';

angular.module('app.resources').factory('Account', ($q, $resource) => {
  let Account = $resource(`${API_ROOT}/accounts/:id`, { id: '@id' }, {
    get: {
      method: 'GET',
      transformResponse: (data) => {
        const account = angular.fromJson(data);
        if (!account.internal_metadata) {
          account.internal_metadata = {};
        }
        return account;
      }
    },
    update: {
      method: 'PUT'
    },
    impersonate: {
      method: 'POST',
      url: `${API_ROOT}/user/impersonate_account/:id`
    },
    stopImpersonating: {
      method: 'POST',
      url: `${API_ROOT}/user/stop_impersonating`
    }
  });

  Account.prototype.hasExtraFeature = function(extraFeature) {
    return this.extra_features.split(/\s+/).indexOf(extraFeature) >= 0;
  };

  Account.prototype.hasFeatureFlag = function (featureFlag) {
    return this.feature_flags.indexOf(featureFlag) >= 0;
  };

  return Account;
});



// WEBPACK FOOTER //
// ./resources/account.js